import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { ArrowLeft } from "lucide-react";

export function LegalPage({ title, updated, intro, sections, testid }) {
  return (
    <div data-testid={testid} className="min-h-screen bg-[#0A0A0A] text-white">
      <header className="sticky top-0 z-40 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-[#2E3033]">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-5 h-16">
          <Link to="/"><Logo className="h-9" /></Link>
          <nav className="flex items-center gap-2">
            <Link to="/terms" className="hidden sm:block text-[11px] font-mono uppercase tracking-[0.15em] text-[#A0AABF] hover:text-white px-3 py-2 transition-colors">Terms</Link>
            <Link to="/privacy" className="hidden sm:block text-[11px] font-mono uppercase tracking-[0.15em] text-[#A0AABF] hover:text-white px-3 py-2 transition-colors">Privacy</Link>
            <Link to="/register" className="bg-[#2560C9] hover:bg-[#3B75DF] text-white text-sm px-4 py-2 transition-colors">Get Started</Link>
          </nav>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        <Link to="/" className="inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-[0.15em] text-[#6E7787] hover:text-white transition-colors">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to home
        </Link>
        <h1 className="mt-6 font-heading font-black text-4xl sm:text-5xl tracking-tight">{title}</h1>
        <p className="mt-3 text-[11px] font-mono uppercase tracking-[0.15em] text-[#6E7787]">Last updated · {updated}</p>

        <div className="mt-8 space-y-3 border-l-2 border-[#2560C9]/50 pl-4">
          {intro.map((p, i) => (
            <p key={i} className="text-sm text-[#A0AABF] leading-relaxed">{p}</p>
          ))}
        </div>

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading font-bold text-lg text-white">
                <span className="text-[#3B75DF] font-mono text-sm mr-2">{String(i + 1).padStart(2, "0")}</span>
                {s.h}
              </h2>
              <div className="mt-3 space-y-3">
                {s.p?.map((p, j) => (
                  <p key={j} className="text-sm text-[#A0AABF] leading-relaxed">{p}</p>
                ))}
                {s.list && (
                  <ul className="space-y-1.5">
                    {s.list.map((li, j) => (
                      <li key={j} className="text-sm text-[#A0AABF] leading-relaxed flex gap-2">
                        <span className="text-[#2560C9] mt-2 w-1 h-1 bg-[#2560C9] shrink-0" />
                        <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-[#2E3033] flex flex-wrap items-center justify-between gap-3">
          <p className="text-[11px] font-mono text-[#6E7787]">© {new Date().getFullYear()} EAZIKAST — Yard Organizer</p>
          <div className="flex items-center gap-4 text-[11px] font-mono uppercase tracking-[0.15em] text-[#6E7787]">
            <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
